import { Calendar } from 'lucide-react';
import type { ReactNode } from 'react';

import { cn } from '@shigo-ui/ui';

import { DashboardTableStatusTone } from './DashboardDataTable.types';

export function DashboardTableStatusBadge({
  children,
  tone = DashboardTableStatusTone.Neutral,
}: {
  children?: ReactNode | undefined;
  tone?: DashboardTableStatusTone | undefined;
}) {
  return (
    <span
      data-tone={tone}
      className={cn(
        'inline-flex items-center gap-1 rounded-full px-2 py-[3px] text-[10px] font-bold tracking-[0.06em] uppercase',
        dashboardStatusToneClassName(tone),
      )}
    >
      {children}
    </span>
  );
}

export function DashboardTableDateCell({ children }: { children: ReactNode }) {
  return (
    <span className="inline-flex items-center gap-2">
      <Calendar className="text-muted-foreground h-3.5 w-3.5" aria-hidden="true" />
      {children}
    </span>
  );
}

function dashboardStatusToneClassName(tone: DashboardTableStatusTone) {
  switch (tone) {
    case DashboardTableStatusTone.Success:
      return 'bg-[var(--status-success-bg)] text-[var(--status-success-text)]';
    case DashboardTableStatusTone.Warning:
      return 'bg-[var(--status-warning-bg)] text-[var(--status-warning-text)]';
    case DashboardTableStatusTone.Info:
      return 'bg-[var(--status-info-bg)] text-[var(--status-info-text)]';
    case DashboardTableStatusTone.Danger:
      return 'bg-destructive/10 text-destructive';
    case DashboardTableStatusTone.Neutral:
    default:
      return 'bg-[var(--status-neutral-bg)] text-[var(--status-neutral-text)]';
  }
}
